<div>
  <ion-grid>
    <ion-row>
      <p class="c2c-options-explanation">{{ "convert-to-cash.credit_winning" | translate }}</p>
    </ion-row>
    <ion-row class="c2c-card-wrapper">
      <ion-col
        (click)="chooseOption('credit')"
        class="ion-no-padding"
        [ngClass]="!isCreditSelected ? 'card-position' : ''"
        >
        <ion-card class="c2c-card" [ngClass]="isCreditSelected ? 'selected-option-highlight' : ''">
          <ion-checkbox color="secondary" [checked]="isCreditSelected" class="c2c-option-checkbox"></ion-checkbox>
          <h1 class="balance-amount">{{ currencySymbol }} {{ credit | displayCurrency }}</h1>
          <h1 class="cash-option">{{ "convert-to-cash.credit_card" | translate }}</h1>
        </ion-card>
      </ion-col>
      <ion-col (click)="chooseOption('cash')" class="ion-no-padding">
        <ion-card class="c2c-card" [ngClass]="isCashSelected ? 'selected-option-highlight' : ''">
          <ion-checkbox color="secondary" [checked]="isCashSelected" class="c2c-option-checkbox"></ion-checkbox>
          <h1 class="balance-amount">{{ currencySymbol }} {{ cash | displayCurrency }}</h1>
          <h1 class="cash-option">{{ "convert-to-cash.cash1" | translate }}</h1>
        </ion-card>
      </ion-col>
    </ion-row>

    @if (isCreditSelected) {
      <div>
        <div class="first-time-offers splitter-line-bottom">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ creditDesc }}</h1>
        </div>
        <div class="first-time-offers splitter-line-bottom">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ "convert-to-cash.credit_issue" | translate }}</h1>
        </div>
        <div class="first-time-offers">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ "convert-to-cash.credit_spent" | translate }}</h1>
        </div>
      </div>
    }

    @if (!isCreditSelected) {
      <div>
        <div class="first-time-offers splitter-line-bottom">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ "convert-to-cash.winnings" | translate }}</h1>
        </div>
        <div class="first-time-offers splitter-line-bottom">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ cashDesc }}</h1>
        </div>
        <div class="first-time-offers">
          <ion-icon name="checkmark"></ion-icon>
          <h1>{{ "convert-to-cash.account" | translate }}</h1>
        </div>
      </div>
    }

    <ion-row>
      <ion-button
        (click)="creditToCashConversion(); startSpinner()"
        [disabled]="disableConvertToCashButton"
        expand="block"
        color="secondary"
        class="capsule-btn common-margin"
        type="submit"
        >
        @if (!spinnerAnimation && proceed) {
          <span> {{"convert-to-cash.choose" | translate }}  {{ optionType | titlecase }}</span>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner
              mode="determinate"
              value="100"
              class="track-spinner"
              diameter="40"
            ></mat-progress-spinner>
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
        }
      </ion-button>
    </ion-row>
  </ion-grid>
</div>
